import { useState } from 'react';
import { message } from 'antd';

export interface BizListProp {
  uuid: string;
  cnName: string;
  enName: string;
  parentUuid: string;
  subjectList: string[];
  children: BizListProp[];
}

function useBizList() {
  const [bizList, setBizList] = useState<BizListProp[]>([]);
  const [totalCount, setTotalCount] = useState(0);

  const fetchBizList = (page = 1, pageSize = 10) => {
    const url =
      alo7Api.prefix.host +
      `/api/v1/business_config?pageNo=${page}&pageSize=${pageSize}`;
    alo7Api
      .fetch(url)
      .then((res: { totalCount: number; result: BizListProp[] }) => {
        setBizList(res.result);
        setTotalCount(res.totalCount);
      })
      .catch(err => message.error(err.message));
  };

  return { bizList, fetchBizList, totalCount };
}

export default useBizList;
